<template>
<div>
    <!-- <div class="alert_messages">
        <p>Event scheduled succesfully</p>
        <a>Undo</a>
    </div> -->
    <header class="d-flex"> 
        <div id="logo">
            <a href="#">
                <svg width="146" height="32" viewBox="0 0 146 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 24.884V4.72119H1.99108V16.4361L13.1088 4.69206H15.2936L7.05398 13.5667L15.7305 24.884H13.4831L5.77515 14.7611L1.98816 18.6937V24.884H0ZM18.3916 20.6178C18.3735 19.7619 18.6553 18.9266 19.1883 18.2567C19.7626 17.5414 20.5166 16.9915 21.3731 16.6633C22.4174 16.2669 23.5277 16.0736 24.6445 16.0938C25.3979 16.0969 26.1497 16.1636 26.8919 16.2933C27.5977 16.3903 28.293 16.5522 28.9689 16.7769V15.5257C28.9689 14.2731 28.599 13.2773 27.8591 12.5384C27.1191 11.7994 26.0952 11.4295 24.7872 11.4285C23.9888 11.4335 23.1983 11.5882 22.4568 11.8844C21.601 12.2096 20.7889 12.6396 20.039 13.1647L19.299 11.7985C20.178 11.1805 21.1357 10.6828 22.1466 10.3186C23.0567 9.98003 24.02 9.80641 24.9912 9.80594C26.8118 9.80594 28.2533 10.3274 29.3156 11.3703C30.3779 12.4131 30.909 13.859 30.909 15.7078V22.5535C30.909 23.0647 31.145 23.3298 31.6198 23.3488V24.884C31.3284 24.9341 31.0326 24.9531 30.7372 24.9408C30.2638 24.9218 29.9026 24.7703 29.6564 24.4863C29.4254 24.2361 29.2854 23.9155 29.2588 23.576L29.2297 22.4952C28.5457 23.3636 27.6562 24.0479 26.6414 24.4863C25.6191 24.9351 24.5156 25.1696 23.3992 25.1753C22.5005 25.1919 21.6115 24.9867 20.8109 24.5781C20.0827 24.1893 19.4656 23.6214 19.0179 22.9278C18.6018 22.2312 18.3852 21.4336 18.3916 20.6221V20.6178ZM28.3193 21.7553C28.7563 21.2426 28.9748 20.7683 28.9748 20.3323V18.1752C27.6695 17.6636 26.2794 17.4032 24.8775 17.4076C23.4938 17.4076 22.3772 17.6824 21.5275 18.232C20.6779 18.7816 20.2506 19.5307 20.2458 20.4794C20.2458 21.2951 20.5584 22.0345 21.1838 22.6977C21.8295 23.3619 22.7209 23.694 23.858 23.694C24.7495 23.7018 25.6323 23.5175 26.4462 23.1536C27.1779 22.8539 27.8221 22.3745 28.3193 21.7597V21.7553ZM49.254 24.884H47.3198V16.6109C47.3198 14.863 47.0542 13.5924 46.5231 12.7991C46.0104 11.9835 45.2136 11.5756 44.1329 11.5756C43.3488 11.5817 42.5778 11.7771 41.8855 12.1451C41.1374 12.5117 40.4703 13.0242 39.9235 13.6526C39.3731 14.2778 38.9656 15.0154 38.7292 15.8141V24.884H36.7949V10.0681H38.5573V13.4181C39.1594 12.32 40.0563 11.4119 41.147 10.7964C42.2668 10.137 43.5442 9.79277 44.8437 9.80012C45.9448 9.80012 46.8187 10.0657 47.4654 10.5968C48.1102 11.1095 48.5656 11.849 48.8317 12.8151C49.1361 13.917 49.2798 15.0571 49.2584 16.2001L49.254 24.884ZM67.5437 24.884H65.6094V16.6109C65.6094 13.2531 64.4719 11.5747 62.1968 11.5756C61.4393 11.5799 60.6952 11.7758 60.0338 12.1451C59.315 12.5193 58.677 13.0316 58.1564 13.6526C57.6243 14.2817 57.2361 15.0194 57.0188 15.8141V24.884H55.0845V4.12256H57.0188V13.4254C57.5841 12.3475 58.4294 11.4418 59.4658 10.8037C60.4757 10.1548 61.6504 9.80903 62.8508 9.8074C63.9888 9.8074 64.8991 10.0827 65.5818 10.6333C66.2615 11.1634 66.7543 11.9126 67.0601 12.8807C67.4023 13.9557 67.5656 15.0795 67.5437 16.2074V24.884ZM72.1813 20.6178C72.1618 19.764 72.4416 18.9303 72.9722 18.2611C73.546 17.5453 74.3001 16.9953 75.157 16.6677C76.2012 16.2713 77.3116 16.078 78.4284 16.0982C79.1871 16.1004 79.9444 16.1671 80.6918 16.2977C81.3975 16.3947 82.0928 16.5565 82.7688 16.7813V15.5301C82.7688 14.2775 82.3989 13.2817 81.659 12.5428C80.919 11.8038 79.8951 11.4339 78.5871 11.4329C77.7886 11.4376 76.9981 11.5922 76.2567 11.8888C75.4007 12.2136 74.5886 12.6437 73.8388 13.1691L73.0989 11.8028C73.9745 11.1841 74.9286 10.685 75.9362 10.3186C76.8464 9.98003 77.8097 9.80641 78.7808 9.80594C80.6015 9.80594 82.0425 10.3274 83.1038 11.3703C84.1651 12.4131 84.6963 13.859 84.6973 15.7078V22.5535C84.6973 23.0643 84.9342 23.3293 85.4081 23.3488V24.884C85.1196 24.9335 84.8266 24.9526 84.5341 24.9408C84.0593 24.9223 83.6991 24.7708 83.4534 24.4863C83.2214 24.2367 83.0807 23.9158 83.0543 23.576L83.0266 22.4952C82.3403 23.3659 81.4477 24.0518 80.4296 24.4907C79.407 24.938 78.3036 25.1709 77.1874 25.1753C76.2887 25.1917 75.3998 24.9866 74.5991 24.5781C73.8709 24.1893 73.2538 23.6214 72.8061 22.9278C72.3905 22.2311 72.1743 21.4334 72.1813 20.6221V20.6178ZM82.109 21.7553C82.545 21.2426 82.763 20.7683 82.763 20.3323V18.1752C81.4582 17.6638 80.0686 17.4034 78.6672 17.4076C77.2826 17.4076 76.1635 17.6824 75.3099 18.232C74.4564 18.7816 74.0296 19.5307 74.0296 20.4794C74.0296 21.2951 74.3428 22.0345 74.9691 22.6977C75.6129 23.3619 76.5038 23.694 77.6418 23.694C78.5338 23.7016 79.417 23.5173 80.2316 23.1536C80.9644 22.8538 81.61 22.3744 82.109 21.7597V21.7553Z" fill="#2A85D0"/>
                    <path d="M126.111 24.8838H124.177V16.6107C124.177 14.8628 123.911 13.5922 123.38 12.7989C122.869 11.9833 122.073 11.5754 120.991 11.5754C120.207 11.5814 119.436 11.7768 118.744 12.1449C117.995 12.5114 117.328 13.024 116.78 13.6524C116.231 14.278 115.823 15.0155 115.586 15.8139V24.8838H113.652V10.0679H115.416V13.4179C116.017 12.3199 116.914 11.4118 118.004 10.7962C119.124 10.1368 120.402 9.79253 121.702 9.79992C122.802 9.79992 123.676 10.0655 124.324 10.5966C124.968 11.1093 125.423 11.8488 125.689 12.8149C125.993 13.9168 126.137 15.0569 126.115 16.1999L126.111 24.8838ZM138.346 25.1678C137.001 25.1891 135.678 24.8241 134.534 24.1162C133.423 23.4225 132.512 22.4517 131.889 21.2992C131.259 20.1182 130.927 18.8012 130.922 17.4627C130.917 16.1242 131.239 14.8047 131.86 13.6189C132.485 12.4837 133.397 11.5324 134.505 10.8603C135.649 10.1516 136.972 9.78606 138.317 9.8072C139.773 9.8072 141.054 10.1582 142.158 10.8603C143.243 11.5466 144.126 12.5086 144.718 13.6481C145.347 14.7989 145.67 16.0918 145.656 17.403C145.656 17.706 145.646 17.9623 145.627 18.1706H132.938C133.017 19.179 133.331 20.1548 133.855 21.0196C134.347 21.8186 135.016 22.4931 135.812 22.9903C136.604 23.4633 137.511 23.7092 138.433 23.7011C139.393 23.7025 140.336 23.447 141.164 22.9611C141.963 22.528 142.601 21.8499 142.985 21.0269L144.663 21.4813C144.343 22.2262 143.857 22.8878 143.241 23.4156C142.597 23.9786 141.857 24.4225 141.056 24.7264C140.185 25.0342 139.267 25.1861 138.343 25.1751L138.346 25.1678ZM132.884 16.7767H143.833C143.779 15.7802 143.479 14.8127 142.959 13.9612C142.479 13.1608 141.802 12.4964 140.992 12.0313C140.189 11.5649 139.276 11.3192 138.347 11.3192C137.418 11.3192 136.506 11.5649 135.702 12.0313C134.893 12.4958 134.215 13.1597 133.735 13.9598C133.227 14.8179 132.934 15.7857 132.881 16.7811L132.884 16.7767Z" fill="#2659A3"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M107.694 15.999C107.695 18.4749 107.048 20.9079 105.82 23.0576C104.592 25.2073 102.824 26.9991 100.691 28.256C98.5574 29.5129 96.1332 30.1914 93.6575 30.2243C91.1819 30.2572 88.7405 29.6434 86.5748 28.4436H83.4141C85.9234 30.4718 88.9873 31.6939 92.2037 31.9497C95.42 32.2054 98.6385 31.4827 101.437 29.8765C104.235 28.2703 106.482 25.8556 107.884 22.9493C109.285 20.0431 109.775 16.781 109.289 13.5913C108.804 10.4015 107.365 7.4332 105.162 5.07579C102.959 2.71839 100.095 1.08207 96.9453 0.381609C93.7957 -0.318857 90.508 -0.0507477 87.5136 1.15075C84.5191 2.35225 81.9579 4.431 80.166 7.11417H82.3683C84.2097 4.81405 86.7201 3.14259 89.5525 2.33074C92.3848 1.51889 95.3995 1.60672 98.1798 2.5821C100.96 3.55748 103.369 5.37226 105.073 7.77569C106.778 10.1791 107.694 13.0526 107.694 15.999Z" fill="#2659A3"/>
                    <path d="M95.2002 20.8405L89.2532 13.9015C89.1048 13.7253 89.032 13.4975 89.0507 13.2679C89.0694 13.0382 89.178 12.8253 89.353 12.6753C89.5279 12.5253 89.755 12.4505 89.9848 12.4671C90.2146 12.4837 90.4285 12.5904 90.5801 12.764L95.2992 18.2697L113.299 0.268417C113.463 0.106628 113.685 0.0162947 113.915 0.0170951C114.146 0.0178956 114.367 0.109765 114.53 0.272691C114.693 0.435617 114.785 0.656399 114.786 0.886944C114.787 1.11749 114.697 1.33912 114.536 1.50356L95.2002 20.8405Z" fill="#2659A3"/>
                </svg>
            </a>
        </div>
        <div class="header-search">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.1761 16.3522C3.68973 16.3522 0 12.7044 0 8.1761C0 3.68973 3.6478 0 8.1761 0C12.7044 0 16.3522 3.6478 16.3522 8.1761C16.3103 12.7044 12.6625 16.3522 8.1761 16.3522ZM8.1761 1.21593C4.31866 1.21593 1.174 4.36058 1.174 8.21803C1.174 12.0755 4.31866 15.2201 8.1761 15.2201C12.0335 15.2201 15.1782 12.0755 15.1782 8.21803C15.1363 4.36058 11.9916 1.21593 8.1761 1.21593Z" fill="#B0B0B0"/>
                <path d="M19.0776 20L13.3752 14.3397L14.2977 13.4172L19.9581 19.1195L19.0776 20Z" fill="#B0B0B0"/>
            </svg>
            <input type="search" placeholder="Task, contact, meeting, document" />
        </div>
        <div class="header-actions">
            <ul>
                <li v-b-modal.create-modal>
                    <a>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 7.12158H16V8.87845H0V7.12158Z" fill="#58508D"/>
                            <path d="M7.99998 16C7.51484 16 7.12155 15.6067 7.12155 15.1216L7.12155 0.878431C7.12155 0.393287 7.51484 0 7.99998 0C8.48513 0 8.87842 0.393288 8.87842 0.878432V15.1216C8.87842 15.6067 8.48513 16 7.99998 16Z" fill="#58508D"/>
                        </svg>
                    </a>
                    <span>Create</span> 
                </li>
                <li>
                    <router-link to="/notifications">
                        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.3331 17.5108C17.2887 17.5108 16.7553 13.7331 16.222 10.0887C15.6443 6.13321 15.1109 2.44436 10.6665 2.44436C6.22215 2.44436 5.68882 6.17765 5.11105 10.0887C4.57772 13.7331 4.04439 17.5108 0 17.5108V16.3553C2.84441 16.3553 3.37773 13.9553 3.9555 9.95538C4.48883 6.08876 5.19994 1.28882 10.6665 1.28882C16.1331 1.28882 16.8442 6.08876 17.3776 9.95538C17.9553 13.9553 18.4887 16.3553 21.3331 16.3553V17.5108Z" fill="#58508D"/>
                            <path d="M10.6664 20C8.97756 20 7.55535 18.6222 7.55535 16.8889H8.7109C8.7109 17.9556 9.55532 18.8 10.622 18.8C11.6886 18.8 12.5331 17.9556 12.5331 16.8889H13.6886C13.7775 18.6222 12.3553 20 10.6664 20Z" fill="#58508D"/>
                            <path d="M0 16.3108H21.3331V17.5552H0V16.3108Z" fill="#58508D"/>
                            <path d="M11.911 1.24442C11.911 1.95553 11.3332 2.17775 10.6666 2.17775C9.99991 2.17775 9.42213 1.91108 9.42213 1.24442C9.42213 0.577765 9.99991 0 10.6666 0C11.3332 0 11.911 0.533321 11.911 1.24442Z" fill="#58508D"/>
                        </svg>

                    </router-link>
                </li>
                <li class="profile">
                    <a v-b-modal.profile-modal>
                        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.34831 20L0 19.382C0.393258 18.427 1.62921 17.9213 3.0337 17.3034C4.38202 16.6854 6.06741 15.9551 6.06741 15.0562V13.8202C5.56179 13.427 4.77527 12.5281 4.66292 11.2359C4.26966 10.8427 3.65169 10.1124 3.65169 9.21348C3.65169 8.65168 3.8764 8.20224 4.04494 7.92135C3.93258 7.30337 3.70786 6.06741 3.70786 5.11236C3.70786 2.02247 5.84269 0 9.21348 0C10.1685 0 11.3483 0.280889 11.9663 0.955046C13.4831 1.23595 14.7191 3.0337 14.7191 5.11236C14.7191 6.46067 14.4944 7.58427 14.3258 8.08989C14.4944 8.37079 14.6629 8.76404 14.6629 9.21348C14.6629 10.2809 14.1573 10.9551 13.6517 11.2921C13.5393 12.5843 12.809 13.427 12.3596 13.8202V15.0562C12.3596 15.8427 13.764 16.3483 15.0562 16.8539C16.573 17.4157 18.1461 17.9775 18.6517 19.2697L17.2472 19.7753C17.0225 19.1011 15.6742 18.6517 14.5506 18.2022C12.809 17.5843 10.8427 16.8539 10.8427 15.0562V13.0337L11.1798 12.809C11.236 12.809 12.191 12.1348 12.191 10.8427V10.3371L12.6405 10.1685C12.6966 10.1124 13.1461 9.88764 13.1461 9.21348C13.1461 8.98876 12.9775 8.76404 12.9214 8.70786L12.6405 8.37079L12.7528 7.97752C12.7528 7.97752 13.1461 6.74157 13.1461 5.05617C13.1461 3.65168 12.3596 2.35954 11.5169 2.35954H11.0674L10.8427 1.96629C10.6742 1.68539 10 1.40449 9.10112 1.40449C6.57303 1.40449 5.05618 2.7528 5.05618 5.05617C5.05618 6.12359 5.44944 7.86516 5.44944 7.86516L5.5618 8.25842L5.2809 8.53932C5.2809 8.53932 5.05618 8.82022 5.05618 9.10112C5.05618 9.49437 5.56179 9.99999 5.78651 10.2247L6.06741 10.4494V10.8427C6.06741 12.0786 7.13483 12.7528 7.13483 12.7528L7.4719 12.9775V15C7.4719 16.8539 5.39325 17.809 3.53932 18.5955C2.7528 19.0449 1.57303 19.6067 1.34831 20Z" fill="#58508D"/>
                        </svg>
                    </a> 
                </li>
            </ul>
        </div> 
    </header>
    <div class="chat_section">
        <div class="instant_chat_sec" v-if="ischat"  v-bind:class="{ active: ischat}" >
            <div class="chat_head" >
                <a v-on:click="ischat=false; full_chat=true" ><img src="@/assets/images/plus.svg">New Chat</a>
            </div>
            <div class="chat_body">
                 <b-card no-body>
                    <b-tabs pills card>
                    <b-tab title="Favourites" active>
                        <b-card-text>
                            <div class="tab_content">
                                <ul class="users_list">
                                    <li class="online">
                                        <figure>
                                            <span><img src="@/assets/images/puja.svg"></span>
                                            <em></em> 
                                            <small>4</small>    
                                        </figure>
                                        <figcaption>Pooja Rao</figcaption>
                                    </li>
                                    <li>
                                        <figure>
                                            <span><img src="@/assets/images/raju.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Raju Mahotra</figcaption>
                                    </li>
                                    <li class="more_messages">
                                        <figure>
                                            <span><img src="@/assets/images/rohit.png"></span>
                                             <em></em> 
                                            <small>4</small>    
                                        </figure>
                                        <figcaption>Rohit Bal</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/sujit.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Sujith Pai</figcaption>
                                    </li>
                                     <li>
                                        <figure><span><img src="@/assets/images/puja.svg"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Pooja Rao</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/raju.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Raju Mahotra</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/rohit.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Rohit Bal</figcaption>
                                    </li> 
                                </ul>
                                <div class="conversation_sec">
                                    <div class="conversation_wrap">
                                        <ul>
                                            <li>
                                                <div class="conversation_list">
                                                    <div class="message">
                                                        <p>Sir,<br/>
                                                            When you would you to like to schedule the appointment with
                                                            Rohit Bal for Planning Meditation Agenda for 28 Nov,
                                                            Mumbai Tour?
                                                        </p>
                                                    </div>
                                                    <span class="time">Today, 9:30 AM</span>                                                
                                                </div>
                                            </li>
                                            <li class="my_message">
                                                <div class="conversation_list">
                                                    <div class="message">
                                                        <p>8:00 pm 2nd Dec works</p>
                                                    </div>
                                                    <span class="time">Today, 9:30 AM</span>                                                
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="typing_sec">
                                        <ul class="attachments">
                                            <li><a><img src="@/assets/images/clip4.svg"></a></li>
                                            <li><a><img src="@/assets/images/emoji4.svg"></a></li>
                                        </ul>
                                        <div class="typing_cnt">
                                            <input type="text" class="form-control" placeholder="Type Message">
                                            <button><img src="@/assets/images/Polygon.svg"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-text>                     
                    </b-tab>
                    <b-tab title="My Chats">
                        <b-card-text>
                            <div class="tab_content">
                                <ul class="users_list">
                                    <li class="online">
                                        <figure>
                                            <span><img src="@/assets/images/puja.svg"></span>
                                            <em></em> 
                                            <small>4</small>    
                                        </figure>
                                        <figcaption>Pooja Rao</figcaption>
                                    </li>
                                    <li>
                                        <figure>
                                            <span><img src="@/assets/images/raju.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Raju Mahotra</figcaption>
                                    </li>
                                    <li class="more_messages">
                                        <figure>
                                            <span><img src="@/assets/images/rohit.png"></span>
                                             <em></em> 
                                            <small>4</small>    
                                        </figure>
                                        <figcaption>Rohit Bal</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/sujit.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Sujith Pai</figcaption>
                                    </li>
                                     <li>
                                        <figure><span><img src="@/assets/images/puja.svg"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Pooja Rao</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/raju.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Raju Mahotra</figcaption>
                                    </li>
                                    <li>
                                        <figure><span><img src="@/assets/images/rohit.png"></span>
                                            <em></em> 
                                            <small>4</small> 
                                        </figure>
                                        <figcaption>Rohit Bal</figcaption>
                                    </li> 
                                </ul>
                                <div class="conversation_sec">
                                    <div class="conversation_wrap">
                                        <ul>
                                            <li>
                                                <div class="conversation_list">
                                                    <div class="message">
                                                        <p>Sir,<br/>
                                                            When you would you to like to schedule the appointment with
                                                            Rohit Bal for Planning Meditation Agenda for 28 Nov,
                                                            Mumbai Tour?
                                                        </p>
                                                    </div>
                                                    <span class="time">Today, 9:30 AM</span>                                                
                                                </div>
                                            </li>
                                            <li class="my_message">
                                                <div class="conversation_list">
                                                    <div class="message">
                                                        <p>8:00 pm 2nd Dec works</p>
                                                    </div>
                                                    <span class="time">Today, 9:30 AM</span>                                                
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="typing_sec">
                                        <ul class="attachments">
                                            <li><a><img src="@/assets/images/clip4.svg"></a></li>
                                            <li><a><img src="@/assets/images/emoji4.svg"></a></li>
                                        </ul>
                                        <div class="typing_cnt">
                                            <input type="text" class="form-control" placeholder="Type Message">
                                            <button><img src="@/assets/images/Polygon.svg"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-text>  
                    </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
        <div class="full_chat_section" v-if="full_chat" >
            <div class="chat_left">
                <div class="chat_head">
                    <h5>Chat</h5>
                    <a v-b-modal.add-group-modal><img src="@/assets/images/Union.svg">Create Group</a>                    
                </div>
                <input type="text" placeholder="Search people, group" class="chat_search" /> 
                <div class="conversation_content">
                    <div class="chat_list">
                        <h5>Favourites<img src="@/assets/images/star1.svg"></h5>
                        <ul class="fav_list">
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions">
                                        <li>
                                            <a><img src="@/assets/images/mute.svg"></a>
                                        </li>
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li> 
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions">
                                        <li>
                                            <a><img src="@/assets/images/mute.svg"></a>
                                        </li>
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li> 
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="chat_list">
                        <h5>All</h5>
                        <ul>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions">
                                        <li>
                                            <a><img src="@/assets/images/mute.svg"></a>
                                        </li>
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li> 
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                            <li>
                                <div class="d-flex align-items-center">
                                    <figure><img src="@/assets/images/sunil.png"></figure>
                                    <div class="profile-details">
                                        <label>Sunil Swamy</label>
                                        <p>9:40 am, 08/07/2020</p>
                                    </div>
                                </div>
                                <div class="c_time_details">
                                    <ul class="c_time_actions"> 
                                        <li>
                                            <span>1</span>
                                        </li>                                        
                                    </ul>
                                    <span>10:00 am</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="chat_right">
                 <p class="close" v-on:click="ischat=false; full_chat=false"><img src="@/assets/images/close.svg"></p>
                <div class="conversation_profile">
                   
                    <div class="d-flex align-items-center">
                        <figure>
                            <img src="@/assets/images/sunil.png">
                        </figure>
                        <div class="profile_details">
                            <label>Sunil Swamy</label>
                            <p>9:40 am, 08/07/2020</p>
                        </div>
                    </div>
                    <div class="profile_menu">
                        <popper trigger="clickToOpen" :options="{placement: 'bottom'}">
                            <button slot="reference" class="profile_icon">
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </button>
                            <div class="popper">
                                <div class="profile_list">
                                    <ul>
                                        <li>
                                            <a v-b-modal.add-participants-modal>Add participants</a>
                                        </li>
                                        <li>
                                            <a v-b-modal.view-participants-modal>  View participants</a>
                                        </li>
                                        <li>
                                            <a v-b-modal.edit-group-modal>Edit group details</a>
                                        </li>
                                        <li>
                                            <a v-b-modal.mute-group-modal>Mute group</a>
                                        </li>
                                        <li>
                                            <a v-b-modal.exit-group-modal>Leave group</a>
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                        </popper>
                    </div>
                </div>
                <div class="conversation_sec">
                    <div class="conversation_wrap">
                        <ul>
                            <li>
                                <div class="conversation_list">
                                    <div class="message">
                                        <p>Sir,<br/>
                                            When you would you to like to schedule the appointment with
                                            Rohit Bal for Planning Meditation Agenda for 28 Nov,
                                            Mumbai Tour?
                                        </p>
                                    </div>
                                    <span class="time">Today, 9:30 AM</span>                                                
                                </div>
                            </li>
                            <li class="my_message">
                                <div class="conversation_list">
                                    <div class="message">
                                        <p>8:00 pm 2nd Dec works</p>
                                    </div>
                                    <span class="time">Today, 9:30 AM</span>                                                
                                </div>
                            </li>
                            <li>
                                <div class="conversation_list">
                                    <div class="message">
                                        <p>Okay Sir, I will let the team know and also make arrangments for the transportation, hotel and stay. I will need your approval on the credit card use for now. I will put that as an action task to you for documentation purpose
                                        </p>
                                    </div>
                                    <span class="time">Today, 9:30 AM</span>                                                
                                </div>
                            </li>
                            <li class="my_message">
                                <div class="conversation_list">
                                    <div class="message">
                                        <p>Okay. No problem</p>
                                    </div>
                                    <span class="time">Today, 9:30 AM</span>                                                
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="typing_sec">
                        <ul class="attachments">
                            <li><a><img src="@/assets/images/clip4.svg"></a></li>
                            <li><a><img src="@/assets/images/emoji4.svg"></a></li>
                        </ul>
                        <div class="typing_cnt">
                            <input type="text" class="form-control" placeholder="Type Message">
                            <button><img src="@/assets/images/Polygon.svg"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span class="chat_icon" v-on:click="toggleChat()" >
            <img v-if="ischat==false && full_chat==false" src="@/assets/images/chat_icon.svg">
            <img v-else src="@/assets/images/close.png">
        </span>
    </div>

    <!-- Chat Modals -->
    <b-modal ref="my-modal" id="add-group-modal" title="Add Group details" centered hide-footer    size="500"  >
        <div class="group_body">
            <div class="pofile">
                <figure><img src="@/assets/images/yoga.png"></figure>
                <div class="profile_details">
                    <label>Group Name</label>
                    <input type="text"  placeholder="Enter Group Name">
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button @click="hideModal" class="save">save</button>
            </div>
        </div>
    </b-modal>
    <b-modal ref="my-modal" id="edit-group-modal" title="Edit Group details" centered hide-footer    size="500"  >
        <div class="group_body">
            <div class="pofile">
                <figure><img src="@/assets/images/yoga.png"></figure>
                <div class="profile_details">
                    <label>Group Name</label>
                    <input type="text" value="Yoga Group" placeholder="Enter Group Name" />
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button @click="hideModal" class="save">save</button>
            </div>
        </div>
    </b-modal>
    <b-modal ref="my-modal" id="add-participants-modal" title="Add participants" centered hide-footer    size="650"  >
        <div class="group_participants">
            <div class="group_participants_head">
                <div class="pofile">
                    <figure><img src="@/assets/images/yoga.png"></figure>
                    <div class="profile_details">
                        <label>Group Name</label>
                        <p>23 Participants</p>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <button  @click="hideModal" class="save">Confirm</button>
                </div>
            </div>
            <div class="add_participants_list">
                <div class="added_list">
                    <h5>Participants</h5>
                    <ul>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div>
                            <span><img src="@/assets/images/minus.svg"></span>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div> 
                            <span><img src="@/assets/images/minus.svg"></span>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div>
                            <span><img src="@/assets/images/minus.svg"></span>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div>
                            <span><img src="@/assets/images/minus.svg"></span>
                        </li>
                    </ul>
                </div>
                <div class="adding_list">
                    <input type="text" class="form_control" placeholder="Enter  person’s name">
                    <ul>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div>
                            <span><img src="@/assets/images/plus.svg"></span>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div> 
                            <span><img src="@/assets/images/plus.svg"></span>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <figure><img src="@/assets/images/sunil.png"></figure>
                                <figcaption>Sunil Swamy</figcaption>
                            </div>
                            <span><img src="@/assets/images/plus.svg"></span>
                        </li>
                    </ul>
                </div>
            </div> 
        </div>
    </b-modal>
    
    <b-modal id="view-participants-modal" title="View participants" centered hide-footer    size="650"  >
        <div class="group_participants">
            <div class="group_participants_head">
                <div class="pofile">
                    <figure><img src="@/assets/images/yoga.png"></figure>
                    <div class="profile_details">
                        <label>Group Name</label>
                        <p>23 Participants</p>
                    </div>
                </div>
            </div>
            <div class="group_participants_list">
                <ul>
                    <li>
                        <div class="d-flex align-items-center">
                            <figure><img src="@/assets/images/sunil.png"></figure>
                            <figcaption>Sunil Swamy</figcaption>
                        </div>
                        <div class="d-flex align-items-center">
                            <p>
                                <span>Make/Remove Admin</span>
                                <span>Remove</span>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="d-flex align-items-center">
                            <figure><img src="@/assets/images/sunil.png"></figure>
                            <figcaption>Sunitha Rai</figcaption>
                        </div>
                        <div class="d-flex align-items-center">
                            <p>
                                <span>Make/Remove Admin</span>
                                <span>Remove</span>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="d-flex align-items-center">
                            <figure><img src="@/assets/images/sunil.png"></figure>
                            <figcaption>Kamalesh B</figcaption>
                        </div>
                        <div class="d-flex align-items-center">
                            <p>
                                <span>Make/Remove Admin</span>
                                <span>Remove</span>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </b-modal>


    <b-modal ref="my-modal" id="mute-group-modal" centered hide-footer size="650"  >
        <div class="mute_group_wrap">
            <div class="mute_group_left">
                <figure><img src="@/assets/images/mute_group.png"></figure>
                <label>Mute Group</label>
                <p>Notifications are muted for the selected period</p>
            </div>
            <div class="mute_group_right">
                <h5>Mute Group for</h5>
                <form>
                    <b-form-checkbox>8 Hours</b-form-checkbox>
                    <b-form-checkbox>1 Week</b-form-checkbox>
                    <b-form-checkbox>1 Year</b-form-checkbox>
                </form>
                <div class="button_wrap">
                    <button @click="hideModal" class="button">APPLY</button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal ref="my-modal" id="exit-group-modal" centered hide-footer size="650"  >
        <div class="mute_group_wrap">
            <div class="mute_group_left">
                <figure><img src="@/assets/images/men_img.png"></figure>
                <label>Leave Group</label> 
            </div>
            <div class="mute_group_right">
                <div></div>
                <h5>Do you want to leave this group ?</h5> 
                <div class="button_wrap">
                     <button @click="hideModal" class="button no">No</button>
                    <button @click="hideModal" class="button">Yes</button>
                </div>
            </div>
        </div>
    </b-modal>
    <!-- profile modals -->
    <b-modal ref="my-modal" id="profile-modal"   centered hide-footer hide-header>
        <div class="profile_list">
            <ul>
                <li ><a v-b-modal.profileDetails-modal>Profile</a></li>
                <li><a>Change Password</a></li>
                <li @click="hideModal"><router-link to="/give-proxy">Give Proxy</router-link></li> 
                <li @click="hideModal"> <router-link to="/switch-account">Switch Account</router-link></li>
            </ul>
        </div>
    </b-modal>
    <b-modal ref="my-modal" id="create-modal"   centered hide-footer hide-header>
        <div class="profile_list">
            <ul>
                <li @click="hideModal"><router-link to="/create-schedule">Schedule</router-link></li>
                <li @click="hideModal"><router-link to="/create-task">Task</router-link></li>
                <li @click="hideModal"><router-link to="/create-document">Document</router-link></li> 
                <li @click="hideModal"><router-link to="/create-member">Member</router-link></li>
            </ul>
        </div>
    </b-modal>
    <b-modal ref="my-modal" id="profileDetails-modal" size="lg" centered hide-header hide-footer>
            <span class="close" @click="hideModal"><span aria-hidden="true">&times;</span></span>
            <div class="edit-modal"> 
                <div class="edit-pofile">
                    <div class="profile_dp">
                        <figure><img src="@/assets/images/profile.png"></figure>
                        <span><img src="@/assets/images/upload_icon.png"></span>    
                    </div>
                    <div class="profile-details">
                        <h6>Profile Details</h6>
                        <ul>
                            <li>
                                <label>First Name</label>
                                <input class="form-control" type="text" value="Raj">
                            </li>
                            <li>
                                <label>Second Name</label>
                                <input class="form-control" type="text" value="Sinha">
                            </li>
                            <li>
                                <label>Profile Type</label>
                                <multiselect
                                    v-model="Profileselected"
                                    :show-labels="false" 
                                    :options="Profileoptions">
                                </multiselect>
                            </li>
                            <li>
                                <label>Admin Role Type</label>
                                <multiselect
                                    v-model="role"
                                    :show-labels="false" 
                                    :options="roleoptions">
                                </multiselect>
                            </li>
                            <li>
                                <label>Email ID</label>
                                <input class="form-control" type="email" value="raj.sinha@heartfulness.com">
                            </li>
                            <li>
                                <label>Mobile Number</label>
                                <input class="form-control" type="text" value="+91 8829300925">
                            </li>
                            <li>
                                <label>Location</label>
                                <input class="form-control" type="text" value="Bangalore">
                            </li> 
                        </ul>
                    </div>
                </div>
                <div class="modal-foot">
                    <button @click="hideModal">CANCEL</button>
                    <button @click="hideModal">YES</button>
                </div>
            </div>
        </b-modal>
</div>
</template>
<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
    components: { 
        Popper
    },
    data() {
      return {
        full_chat:false,
        ischat: false,
      }
    },
    methods: {
        toggleChat(){             
            if(this.full_chat) {
                this.ischat=false;
                this.full_chat=false;
            }
            else {
                this.ischat=!this.ischat
            }
        },
        showModal() {
        this.$refs['my-modal'].show() 
        },
        hideModal() {
            this.$refs['my-modal'].hide() 
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['my-modal'].toggle('#toggle-btn') 
        },
    }
}

</script>